<template>
    <div class="bg-white" v-observe-visibility="lazyLoaded ? false : { callback: lazyLoadEuLogo, once: true }">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-xl-8 offset-xl-2 py-5 logos">
                    <a href="https://www.varninainternetu.si/" aria-label="Spletna stran Varni na internetu" class="pr-md-3">
                        <VarniNaInternetu/>
                    </a>
                    <a href="https://www.cert.si/" aria-label="Spletna stran Si-Cert" class="px-md-3">
                        <SiCert/>
                    </a>
                    <a href="https://cybersecuritymonth.eu/" aria-label="Spletna stran evropskega meseca kibervarnosti" class="px-md-3">
                        <EvropskiMesecKibervarnosti/>
                    </a>
                    <a href="https://www.gov.si/teme/informacijska-varnost/" aria-label="Spletna stran ministrstva za javno upravo" class="px-md-3">
                        <MinistrstvoZaJavnoUpravo/>
                    </a>
                    <a href="https://ec.europa.eu/inea/en/connecting-europe-facility" aria-label="Spletna stran instrumenta za povezovanje Evrope Evropske unije" class="pl-md-3">
                        <img :data-src="require('../assets/eu.png')"
                             alt="Sofinancirano s pomočjo instrumenta za povezovanje Evrope Evropske unije"
                             class="eu">
                    </a>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
	import VarniNaInternetu from '@/svg/varni-na-internetu'
	import SiCert from '@/svg/si-cert'
	import EvropskiMesecKibervarnosti from '@/svg/evropski-mesec-kibervarnosti'
	import MinistrstvoZaJavnoUpravo from '@/svg/ministrstvo'

	export default {
		name: "Logos",
		components: {
			VarniNaInternetu,
			SiCert,
			EvropskiMesecKibervarnosti,
			MinistrstvoZaJavnoUpravo,
		},
		data() {
			return {
				lazyLoaded: false,
			}
		},
		methods: {
			lazyLoadEuLogo(isVisible) {
				if (this.lazyLoaded || !isVisible) return;

				document.querySelectorAll('.eu').forEach(element => {
					element.classList.remove('eu');
					element.src = element.dataset.src;
				});

				this.lazyLoaded = true;
			},
		},
	}
</script>